import { Form } from 'antd';

export const SContainerForm = Form;
